<template>
    <b-card>
        <Form
            ref="createActor"
            :submit="submit"
        />
    </b-card>
</template>

<script>
import Form from "./partials/Form";
import { mapActions } from "vuex";

export default {
    name: "CreateActor",

    components: {
        Form
    },

    methods: {
        ...mapActions({
            createActor: 'genre/create'
        }),
        submit() {
            const refActor = this.$refs.createActor
            refActor.errMessage = null

            const data = JSON.parse(JSON.stringify(refActor.genre))
            data.meta_keywords = data.meta_keywords.toString()
            this.createActor(data).then(() => {
                this.$router.push({ name: 'genres' })
            }).catch(response => {
                if (response.errors) {
                    refActor.$refs.form.setErrors(response.errors)
                }
                refActor.errMessage = response.message
            })
        }
    }
}
</script>
